/*
These functions make sure WordPress
and Foundation play nice together.
*/
jQuery(document).ready(function() {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}		
	});


	// Change burger menu button to X on click
    jQuery('#menuButton').click(function(event) {
		event.preventDefault();
		jQuery('#menuButton').addClass('is-active');

	});

  // Removes the x on the burger menu when off canvas is closed
  jQuery("#off-canvas").on("closed.zf.offcanvas", function() {
    jQuery('#menuButton').removeClass("is-active");
    // getInspectionTalk.classList.remove('close-out');
  });

  // animal in the news button toggle
  jQuery(".an-body").hide();
  jQuery(".an-toggle").click( function(){
	  jQuery(this).text( jQuery(this).text() === "Open Article +" ? "Close Article -" : "Open Article +" );
	  jQuery(".an-body").slideToggle(900);
  } );

}); 

// fix Gravity Forms captcha ADA compliance
jQuery(window).on('load', function () {
    var textarea = document.getElementById("g-recaptcha-response");
    if (textarea != '' && textarea != null) {
		textarea.setAttribute("aria-hidden", "true");
		textarea.setAttribute("aria-label", "do not use");
		textarea.setAttribute("aria-readonly", "true");
	}
	jQuery('iframe').removeAttr('frameborder');
	//jQuery('iframe').removeAttribute('frameborder');
});

// // Hide Content and "Show Less" Button(s)
// jQuery(window).load(function() {
// 	jQuery('.read-more-content-1').hide();
// 	jQuery('.read-more-content-2').hide();
// 	jQuery('#btn-show-less-1').hide();
// 	jQuery('#btn-show-less-2').hide();
// });

// // Read More Button 1 - Expand (Hide "Read More" / Show Content and "Read Less")
// jQuery('#btn-read-more-1').click(function() {
//     jQuery('#btn-read-more-1').hide();
//     jQuery('.read-more-content-1').show('linear');
//     jQuery('#btn-show-less-1').show();
// });

// // Read More Button 2
// jQuery('#btn-read-more-2').click(function() {
//     jQuery('#btn-read-more-2').hide();
//     jQuery('.read-more-content-2').show('linear');
//     jQuery('#btn-show-less-2').show();
// });

// // Show Less Button 1 - Collapse (Hide Content and "Show Less" / Show "Read More")
// jQuery('#btn-show-less-1').click(function() {
//     jQuery('#btn-show-less-1').hide();
//     jQuery('.read-more-content-1').hide('linear');
//     jQuery('#btn-read-more-1').show();
// });

// // Show Less Button 2
// jQuery('#btn-show-less-2').click(function() {
//     jQuery('#btn-show-less-2').hide();
//     jQuery('.read-more-content-2').hide('linear');
//     jQuery('#btn-read-more-2').show();
// });






// jQuery(".read-more-toggle-1, .read-more-toggle-2").attr( 'aria-label', 'Toggle the content' );
// jQuery(".read-more-toggle-1, .read-more-toggle-2").click(function() {
//   var id = "";
//   if (jQuery(this).hasClass("read-more-toggle-1")) { id = "1"; }
//   else if (jQuery(this).hasClass("read-more-toggle-2")) { id = "2"; }

//   jQuery(this).toggleClass("container-expanded");
//   if (jQuery(this).hasClass("container-expanded")) {
//     var containerHeight = parseInt(`${jQuery(".read-more-content-" + id + " .kt-inside-inner-col").get(0).scrollHeight}`);
//     console.log(containerHeight);
//     jQuery(this).text('Show Less');
//     jQuery(`.read-more-content-${id}`).css("height", `${containerHeight+100}px`);
//     jQuery(`.read-more-content-${id} .kt-inside-inner-col`).css({"height": `${containerHeight}px`, "margin-bottom": "6rem"});
//     setTimeout(function() {
//       jQuery(`.read-more-toggle-${id}`).attr("href", `#read-more-top-${id}`);
//       }, 500);
//   } else {
//     jQuery(this).text('Read More');
//     jQuery(`.read-more-content-${id}, .read-more-content-${id} .kt-inside-inner-col`).css({"height": 165, "margin-bottom": ""});
//     setTimeout(function() {
//       jQuery(`.read-more-toggle-${id}`).attr("href", "javascript:void(0);");
//       }, 500);
//   }
//   jQuery(`.read-more-content-${id}`).toggleClass("expanded");
//   jQuery(`.read-more-content-${id} .kt-inside-inner-col`).toggleClass("mobile-expanded");
// });








// woocommerce anywhere product notification .info class .post-14938
jQuery(".woocommerce.archive .post-19141").click(function () {
	jQuery(".woocommerce.archive .post-19141").addClass("notify");
    jQuery(".woocommerce.archive .post-19141 h2").fadeOut(function () {
    jQuery(".woocommerce.archive .post-19141 h2").text((jQuery(".post-19141 h2").text() == 'We are currently gathering your Product') ? 'HECSTYLE™ ANYWHERE System' : 'We are currently gathering your HECSTYLE™ ANYWHERE System Product').fadeIn();
    })
});

// woocommerce green product notification 
jQuery(".woocommerce.archive .post-20208").click(function () {
	jQuery(".woocommerce.archive .post-20208").addClass("notify");
    jQuery(".woocommerce.archive .post-20208 h2").fadeOut(function () {
    jQuery(".woocommerce.archive .post-20208 h2").text((jQuery(".post-20208 h2").text() == 'We are currently gathering your Product') ? 'HECSTYLE™ GREEn System' : 'We are currently gathering your HECSTYLE™ GREEN System Product').fadeIn();
    })
});

jQuery('.showHide').hide();
jQuery('.showHide-2').hide();
jQuery('.showHide-3').hide();

// Toggle buttons
jQuery('.toggle').click(function(e){
  e.preventDefault();
  jQuery('.showHide').slideToggle();
  jQuery(this).text( jQuery(this).text() == 'Read More' ? "Show Less" : "Read More"); // using ternary operator.
});

jQuery('.toggle-2').click(function(e){
  e.preventDefault();
  jQuery('.showHide-2').slideToggle();
  jQuery(this).text( jQuery(this).text() == 'Read More' ? "Show Less" : "Read More"); // using ternary operator.
});

jQuery('.toggle-3').click(function(e){
  e.preventDefault();
  jQuery('.showHide-3').slideToggle();
  jQuery(this).text( jQuery(this).text() == 'Read More' ? "Show Less" : "Read More"); // using ternary operator.

});
